export default "__VITE_ASSET__BPxdB2dL__"